export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.svg?3c45c98f6f6c1b009c082510d0255ef4";